import { useTrpc, type RouterInput, type RouterOutput } from '#composables/useTrpc';
import type { DataTypeFromSuccessResponse } from '@carrefour-gcs/shared';
import type { QueryFunctionContext } from '@tanstack/vue-query';

type SearchProductNomenclatureFiltersOutput = RouterOutput['core']['filter']['searchProductNomenclatureFilters'];
export type ProductNomenclatureFilterType = DataTypeFromSuccessResponse<SearchProductNomenclatureFiltersOutput>;

type SearchProductNomenclatureFiltersInput = RouterInput['core']['filter']['searchProductNomenclatureFilters'];
export async function searchFilters(query: SearchProductNomenclatureFiltersInput) {
  return useTrpc().core.filter.searchProductNomenclatureFilters.query(query);
}

type SearchListFiltersOutput = RouterOutput['core']['filter']['listUserFilters'];
export type ListFiltersType = DataTypeFromSuccessResponse<SearchListFiltersOutput>;

type ListFiltersInput = RouterInput['core']['filter']['listUserFilters'];
export async function listUserFilters(query: ListFiltersInput) {
  return useTrpc().core.filter.listUserFilters.mutate(query);
}

type SearchFormatsInput = RouterInput['core']['filter']['searchFormats'];
export async function searchFormats(query: SearchFormatsInput) {
  return useTrpc().core.filter.searchFormats.query(query);
}

type SearchActivityTypesOutput = RouterOutput['core']['filter']['listActivityTypes'];
export type ActivityTypesType = DataTypeFromSuccessResponse<SearchActivityTypesOutput>;

type SearchActivityTypeInput = RouterInput['core']['filter']['listActivityTypes'];
export async function listActivityTypes(query: SearchActivityTypeInput, { signal }: QueryFunctionContext) {
  return useTrpc().core.filter.listActivityTypes.query(query, { signal });
}

type SearchStoresOutput = RouterOutput['core']['filter']['searchStores'];
export type StoresFilterType = DataTypeFromSuccessResponse<SearchStoresOutput>;

type SearchStoresInput = RouterInput['core']['filter']['searchStores'];
export async function searchStores(query: SearchStoresInput) {
  return useTrpc().core.filter.searchStores.query(query);
}

type SearchStoresRegionInput = RouterInput['core']['filter']['findStoresRegion'];
export async function findStoresRegion(query: SearchStoresRegionInput) {
  return useTrpc().core.filter.findStoresRegion.query(query);
}

type SearchIntegratedFranchisedOutput = RouterOutput['core']['filter']['listIntegratedFranchised'];
export type IntegratedFranchisedType = DataTypeFromSuccessResponse<SearchIntegratedFranchisedOutput>;

type SearchIntegratedFranchisedInput = RouterInput['core']['filter']['listIntegratedFranchised'];
export async function listIntegratedFranchised(query: SearchIntegratedFranchisedInput) {
  return useTrpc().core.filter.listIntegratedFranchised.query(query);
}

export async function findBrands(query: SearchInputType) {
  return useTrpc().core.filter.findBrands.query(query);
}

type FindBusinessBrandsOutput = RouterInput['core']['filter']['findBusinessBrands'];
export type BusinessBrandsType = DataTypeFromSuccessResponse<FindBusinessBrandsOutput>;

export async function findBusinessBrands(query: SearchInputType) {
  return useTrpc().core.filter.findBusinessBrands.query(query);
}

export async function findHoldings(query: SearchInputType) {
  return useTrpc().core.filter.findHoldings.query(query);
}

type SearchInputType = RouterInput['core']['filter']['findSuppliers'];

export async function searchSuppliers(query: SearchInputType) {
  return useTrpc().core.filter.findSuppliers.query(query);
}

type SearchAssortmentTypologiesOutput = RouterOutput['core']['filter']['findAssortmentTypologies'];
export type AssortmentTypologiesType = DataTypeFromSuccessResponse<SearchAssortmentTypologiesOutput>;

type SearchAssortmentTypologiesInput = RouterInput['core']['filter']['findAssortmentTypologies'];
export async function findAssortmentTypologies(query: SearchAssortmentTypologiesInput) {
  return useTrpc().core.filter.findAssortmentTypologies.query(query);
}

type SearchProductTypologiesOutput = RouterOutput['core']['filter']['findProductTypologies'];
export type ProductTypologiesType = DataTypeFromSuccessResponse<SearchProductTypologiesOutput>;

type SearchProductTypologiesInput = RouterInput['core']['filter']['findProductTypologies'];
export async function findProductTypologies(query: SearchProductTypologiesInput) {
  return useTrpc().core.filter.findProductTypologies.query(query);
}

type GetPerimeterAvailableFiltersInput = RouterInput['core']['filter']['getPerimeterAvailableFilters'];
export async function getPerimeterAvailableFilters(query: GetPerimeterAvailableFiltersInput) {
  return useTrpc().core.filter.getPerimeterAvailableFilters.query(query);
}

type SearchBarcodesForCompetitorPerimeterInput = RouterInput['core']['filter']['searchBarcodesForCompetitorPerimeter'];
export async function searchBarcodesForCompetitorPerimeter(query: SearchBarcodesForCompetitorPerimeterInput) {
  return useTrpc().core.filter.searchBarcodesForCompetitorPerimeter.mutate(query);
}

type FindCustomerSegmentationSegmentsInput = RouterInput['core']['filter']['findCustomerSegmentationSegments'];

export async function findCustomerSegmentationSegments(query: FindCustomerSegmentationSegmentsInput) {
  return useTrpc().core.filter.findCustomerSegmentationSegments.query(query);
}
